import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import Icon from '../../../generic-components/Icon';
import { accessRestricted, passwordIcon } from '../../../assets/svg';
import Heading from '../../../generic-components/Heading';
import { SERVER_ERRORS_DATA } from '../../../constants/serverErrors';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { navigateToContinueWhereYouLeft, VIEWS_MAP } from '../../../router/constants';
import { ReactComponent as SignupIcon } from '../../../assets/icons/svg/stamp-icons/ic-stamp-password.svg';

interface IProps {
  email: string;
  errorCode?: number;
  errorCodeName?: string;
  callBack?: () => void;
  redirectUrl?: string;
}

export const IncorrectStateModal = ({ email, errorCode, errorCodeName, callBack, redirectUrl }: IProps) => {
  const navigate = useNavigate();

  const handlePickupWhereLeft = () => {
    navigateToContinueWhereYouLeft(email);
  };

  const handleContinueRecoverPassword = () => {
    navigate(`/${VIEWS_MAP.RECOVERY}/password`);
  };
  const { t } = useTranslation();

  useEffect(() => {
    if (
      errorCode === SERVER_ERRORS_DATA.INVALID_LOGIN_COUNTRY_CODE ||
      errorCodeName === SERVER_ERRORS_DATA.INVALID_LOGIN_COUNTRY_CODE_NAME
    ) {
      trackMixPanel('View INVALID_LOGIN_COUNTRY Pop Up');
    }
  }, []);
  const showContinueRecovery =
    errorCode === SERVER_ERRORS_DATA.PASSWORD_RECOVERY_IN_PROGRESS_CODE ||
    errorCodeName === SERVER_ERRORS_DATA.PASSWORD_RECOVERY_IN_PROGRESS_CODE_NAME;
  return (
    <div
      className={`w-[400px] ${showContinueRecovery ? '' : 'h-[504]  pt-[60px]  pb-[50px]'}   rounded-[8px] bg-bw02 px-[40px] flex flex-col items-center`}
    >
      {errorCode === SERVER_ERRORS_DATA.USER_INCORRECT_STATE_CODE && (
        <>
          <Icon className='w-[100px] mb-[30px]' src={passwordIcon} />
          <Heading
            title={t('LOGIN_ERROR_INCORRECT_STATE_HEADER')}
            className='font-metricMedium text-[1rem] text-bw08 mb-[16px]'
          />
          <p className='font-metric text-center text-[1rem] text-bw07 px-[40px] mb-[10px]'>
            {t('LOGIN_ERROR_INCORRECT_STATE_CONTENT')}
          </p>
          <LiliButton
            onClick={handlePickupWhereLeft}
            className='text-sm mt-[16px]'
            id='Submit-CTA'
            title={t('LOGIN_ERROR_INCORRECT_STATE_CTA')}
          />
        </>
      )}
      {showContinueRecovery && (
        <>
          <Icon className='mt-[34px]' src={passwordIcon} />
          <Heading
            title={t('LOGIN_ERROR_UNFINISHED_RECOVERY_TITLE')}
            className='font-metricRBold text-[20px] text-bw08 text-center mt-[20px]'
          />
          <p className='font-sourceSansPro text-[16px] text-bw08  text-center  mt-[16px]'>
            {t('LOGIN_ERROR_UNFINISHED_RECOVERY_DESCRIPTION')}
          </p>
          <LiliButton
            onClick={handleContinueRecoverPassword}
            className='w-full h-[50px] mt-[24px]'
            id='Submit-CTA'
            title={t('CONTINUE')}
          />
          <LiliButton
            type={LiliButtonType.SECONDARY}
            onClick={callBack}
            className='w-full h-[50px] mt-[12px] mb-[24px]'
            id='Submit-CTA'
            title={t('LATER')}
          />
        </>
      )}
      {(errorCode === SERVER_ERRORS_DATA.INVALID_LOGIN_COUNTRY_CODE ||
        errorCodeName === SERVER_ERRORS_DATA.INVALID_LOGIN_COUNTRY_CODE_NAME) && (
        <>
          <Icon className='w-[100px] h-[100px] mb-[48px]' src={accessRestricted} />
          <Heading title={t('LOGIN_RESTRICTED_HEADER')} className='font-metricMedium text-[1rem] text-bw08 mb-[16px]' />
          <p className='font-metric text-center text-[1rem] text-bw07 whitespace-pre-line'>
            {t('LOGIN_RESTRICTED_TEXT')}
          </p>
          <LiliButton
            onClick={callBack}
            className='w-[160px] h-[50px] text-sm mt-[16px]'
            id='Submit-CTA'
            title='Continue'
          />
        </>
      )}
      {redirectUrl && (
        <>
          <SignupIcon className='mb-[48px]' />
          <Heading
            title={t('NOT_FINISHED_INVITE_HEADER')}
            className='font-metricMedium text-[1rem] text-bw08 mb-[16px]'
          />
          <p className='font-metric text-center text-[1rem] text-bw07 whitespace-pre-line'>
            {t('NOT_FINISHED_INVITE_TEXT')}
          </p>
          <LiliButton
            onClick={() => window.open(redirectUrl)}
            className='h-[50px] w-[200px] text-sm mt-[16px]'
            id='Submit-CTA'
            title={t('NOT_FINISHED_INVITE_BUTTON_TEXT')}
          />
        </>
      )}
    </div>
  );
};
